import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
  Alert,
} from "@mui/material";
import { toWords } from "number-to-words";
import GetPersonData from "../../../../../../../context/GetPersonData";
import { Getrequest, Postrequest } from "../../../../../../../context/AxiosRequest";
import { ContextData } from "../../../../../../../context/Context";
import { useNavigate, useParams } from "react-router-dom";
import SoundAlert from "../../../../../../../routes/SoundAlert";
import { toast } from "react-toastify";

export default function DisbursementUtilizationFormStudentLoan(props) {


  const { UserTokens, accesstoken } = useContext(ContextData);
  const { guarantor, amountOffered } = useParams();
  const Navigate = useNavigate()
  const [form, setForm] = useState({

    user_token: UserTokens || "",
    loanbank_account_number: "empty",
    clientName: "",
    disbursementAmountText: "",
    disbursementAmountFigure: "",
    disbursementStudentName: "",
    sponsorName: "",
    totalAmountRequested: "",
    accept_request:"",
    guarantor:"",

    // Payment type selection
    paymentType: "local", // "local" or "international"
    isInternational: false,
    localSectionChoice: "both", // "remita" | "backing" | "both"

    // A(a)
    a_accountName: "",
    a_remita: "",
    a_amount: "",
    a_studentName: "",
    a_level: "",

    // A(b)
    b_schoolName: "",
    b_schoolAccountName: "",
    b_schoolAccountNumber: "",
    b_bank: "",
    b_studentName: "",
    b_level: "",
    b_matricNo: "",
    b_course: "",
    b_amount: "",

    // A(c)
    c_schoolName: "",
    c_schoolAccountName: "",
    c_schoolAccountNumber: "",
    c_amount: "",
    c_bank: "",
    c_course: "",
    c_iban: "",
    c_swift: "",
    c_branch: "",
    c_matricNo: "",
    c_studentName: "",
    c_level: "",

    // UPKEEP
    up_name: "",
    up_accNo: "",
    up_bank: "",
    up_amount: "",

    // SKILLS
    sk_centre: "",
    sk_centreAcc: "",
    sk_accNo: "",
    sk_bank: "",
    sk_amount: "",

    // OTHERS
    hasOthers: false,
    oth_name: "",
    oth_accNo: "",
    oth_bank: "",
    oth_amount: "",
  });

  const [errors, setErrors] = useState({});

  const formatAmountInput = (value) => {
    if (value === "") return "";
    const sanitized = value.replace(/[^0-9.]/g, "");
    if (!sanitized) return "";
    const hasDot = sanitized.includes(".");
    const parts = sanitized.split(".");
    const intPart = parts[0] || "";
    const decPart = parts[1] || "";
    const intFormatted = intPart
      ? Number(intPart).toLocaleString("en-US")
      : "";
    if (hasDot) {
      return `${intFormatted}.${decPart.slice(0, 2)}`;
    }
    return intFormatted;
  };

  const handleChange = (e) => {
    const amountFields = ["a_amount", "b_amount", "c_amount", "up_amount", "sk_amount", "oth_amount"];
    const isAmountField = amountFields.includes(e.target.name);
    const value = isAmountField ? formatAmountInput(e.target.value) : e.target.value;
    const updatedForm = { ...form, [e.target.name]: value };

    // Calculate total amount if any amount field is changed
    if (isAmountField) {
      const total = calculateTotalAmount(updatedForm);
      updatedForm.totalAmountRequested = total;
      const numericAmount = Number(total.replace(/,/g, ""));
      const amountInWords = Number.isSafeInteger(numericAmount)
        ? toWords(numericAmount)
        : "Amount too large";
      updatedForm.disbursementAmountText = ` ${amountInWords.charAt(0).toUpperCase() + amountInWords.slice(1)} Naira Only (N${numericAmount.toLocaleString()}.00)`;
    }

    setForm(updatedForm);
  };

  const calculateTotalAmount = (formData) => {
    const a_amount = parseFloat(formData.a_amount.replace(/,/g, '')) || 0;
    const b_amount = parseFloat(formData.b_amount.replace(/,/g, '')) || 0;
    const c_amount = parseFloat(formData.c_amount.replace(/,/g, '')) || 0;
    const up_amount = parseFloat(formData.up_amount.replace(/,/g, '')) || 0;
    const sk_amount = parseFloat(formData.sk_amount.replace(/,/g, '')) || 0;
    const oth_amount = parseFloat(formData.oth_amount.replace(/,/g, '')) || 0;

    const total = a_amount + b_amount + c_amount + up_amount + sk_amount + oth_amount;
    return total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    setForm({
      ...form,
      paymentType: value,
      isInternational: value === "international",
      amount_approve: amountOffered
    });
  };

  const handleLocalSectionChoiceChange = (e) => {
    const value = e.target.value;
    setForm((prev) => {
      if (value === "remita") {
        const updatedForm = {
          ...prev,
          localSectionChoice: value,
          b_schoolName: "",
          b_schoolAccountName: "",
          b_schoolAccountNumber: "",
          b_bank: "",
          b_level: "",
          b_amount: "",
        };
        const total = calculateTotalAmount(updatedForm);
        const numericAmount = Number(total.replace(/,/g, ""));
        const amountInWords = Number.isSafeInteger(numericAmount)
          ? toWords(numericAmount)
          : "Amount too large";
        updatedForm.totalAmountRequested = total;
        updatedForm.disbursementAmountText = ` ${amountInWords.charAt(0).toUpperCase() + amountInWords.slice(1)} Naira Only (N${numericAmount.toLocaleString()}.00)`;
        return updatedForm;
      }
      if (value === "backing") {
        const updatedForm = {
          ...prev,
          localSectionChoice: value,
          a_accountName: "",
          a_remita: "",
          a_amount: "",
          a_level: "",
        };
        const total = calculateTotalAmount(updatedForm);
        const numericAmount = Number(total.replace(/,/g, ""));
        const amountInWords = Number.isSafeInteger(numericAmount)
          ? toWords(numericAmount)
          : "Amount too large";
        updatedForm.totalAmountRequested = total;
        updatedForm.disbursementAmountText = ` ${amountInWords.charAt(0).toUpperCase() + amountInWords.slice(1)} Naira Only (N${numericAmount.toLocaleString()}.00)`;
        return updatedForm;
      }
      return { ...prev, localSectionChoice: value };
    });
  };

  const handleOthersRadioChange = (e) => {
    setForm({ ...form, hasOthers: e.target.value === "yes" });
  };

  useEffect(() => {

    const numericAmount = Number(amountOffered.replace(/,/g, ""));
    const amountInWords = toWords(numericAmount);

    (async () => {
      const GetPersonDatas = await GetPersonData(UserTokens);
      const GetPersonLoadData = await Getrequest(
        `/auth/get_loan_data/${UserTokens}`,
        accesstoken
      );

/* 
middle_name 
surname */

      setForm((prevForm) => ({
        ...prevForm,
        clientName: `${GetPersonDatas.bio_data[0]?.fname || ""} ${
          GetPersonDatas.bio_data[0]?.lname || ""
        }`,
        disbursementStudentName: `${GetPersonDatas.bio_data[0]?.fname || ""} ${
          GetPersonDatas.bio_data[0]?.lname || ""
        }`,
        a_studentName: `${GetPersonDatas.bio_data[0]?.fname || ""} ${
          GetPersonDatas.bio_data[0]?.lname || ""
        }`,
        b_studentName: `${GetPersonDatas.bio_data[0]?.fname || ""} ${
          GetPersonDatas.bio_data[0]?.lname || ""
        }`,
        b_course: GetPersonDatas.edu_data[0]?.course_of_study || "",
        b_matricNo: GetPersonDatas.edu_data[0]?.matric_num || "",
        c_course: GetPersonDatas.edu_data[0]?.course_of_study || "",
        c_matricNo: GetPersonDatas.edu_data[0]?.matric_num || "",
        c_studentName: `${GetPersonDatas.bio_data[0]?.fname || ""} ${
          GetPersonDatas.bio_data[0]?.lname || ""
        }`,
        ...GetPersonLoadData.form_data !== undefined
          ? JSON.parse(GetPersonLoadData.form_data)
          : {},
          disbursementAmountFigure: `N${numericAmount.toLocaleString()}.00`,
          sponsorName: GetPersonLoadData.sponsorIdentification[0]?.fname,
           guarantor: `${GetPersonLoadData.guarantor_details[0]?.first_name || ""} ${GetPersonLoadData.guarantor_details[0]?.middle_name || ""} ${GetPersonLoadData.guarantor_details[0]?.surname || ""}`,
      }));
    })();


  }, []);

  const validateForm = () => {
    const newErrors = {};

    // Bank account number is always required
 /*    if (!form.loanbank_account_number.trim()) {
      newErrors.loanbank_account_number =
        "A.B.U Bank account number is required";
    } */

    // Local payment - A(a), A(b) required based on choice
    if (!form.isInternational) {
      if (form.localSectionChoice === "remita" || form.localSectionChoice === "both") {
        if (!form.a_accountName.trim())
          newErrors.a_accountName = "A(a) Account Name is required";
        if (!form.a_remita.trim()) newErrors.a_remita = "A(a) Remita is required";
        if (!form.a_amount.trim()) newErrors.a_amount = "A(a) Amount is required";
        if (!form.a_level.trim()) newErrors.a_level = "A(a) Level is required";
      }

      if (form.localSectionChoice === "backing" || form.localSectionChoice === "both") {
        if (!form.b_schoolName.trim())
          newErrors.b_schoolName = "A(b) School Name is required";
        if (!form.b_schoolAccountName.trim())
          newErrors.b_schoolAccountName = "A(b) School Account Name is required";
        if (!form.b_bank.trim()) newErrors.b_bank = "A(b) Bank is required";
        if (!form.b_level.trim()) newErrors.b_level = "A(b) Level is required";
        if (!form.b_amount.trim())
          newErrors.b_amount = "A(b) Amount is required";
      }
    }
    // International payment - A(c) required
    else {
      if (!form.c_schoolName.trim())
        newErrors.c_schoolName = "A(c) School Name is required";
      if (!form.c_schoolAccountName.trim())
        newErrors.c_schoolAccountName =
          "A(c) School Account Name is required";
      if (!form.c_bank.trim()) newErrors.c_bank = "A(c) Bank is required";
      if (!form.c_iban.trim()) newErrors.c_iban = "A(c) IBAN is required";
      if (!form.c_swift.trim())
        newErrors.c_swift = "A(c) Swift Code is required";
      if (!form.c_branch.trim())
        newErrors.c_branch = "A(c) Branch is required";
      if (!form.c_level.trim()) newErrors.c_level = "A(c) Level is required";
    }

    // Upkeep is always required
    if (!form.up_name.trim())
      newErrors.up_name = "Upkeep Student Account Name is required";
    if (!form.up_accNo.trim())
      newErrors.up_accNo = "Upkeep Account Number is required";
    if (!form.up_bank.trim()) newErrors.up_bank = "Upkeep Bank is required";
    if (!form.up_amount.trim())
      newErrors.up_amount = "Upkeep Amount is required";

    // Skills Acquisition is always required
    if (!form.sk_centre.trim())
      newErrors.sk_centre = "Skills Centre Name is required";
    if (!form.sk_centreAcc.trim())
      newErrors.sk_centreAcc = "Skills Centre Account Name is required";
    if (!form.sk_accNo.trim())
      newErrors.sk_accNo = "Skills Account Number is required";
    if (!form.sk_bank.trim()) newErrors.sk_bank = "Skills Bank is required";
    if (!form.sk_amount.trim())
      newErrors.sk_amount = "Skills Amount is required";

    // Others - optional but required if selected
    if (form.hasOthers) {
      if (!form.oth_name.trim())
        newErrors.oth_name = "Others Account Name is required";
      if (!form.oth_accNo.trim())
        newErrors.oth_accNo = "Others Account Number is required";
      if (!form.oth_bank.trim()) newErrors.oth_bank = "Others Bank is required";
      if (!form.oth_amount.trim())
        newErrors.oth_amount = "Others Amount is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isAmountExceeded = () => {
    const offeredAmount = parseFloat(amountOffered.replace(/,/g, '')) || 0;
    const requestedAmount = parseFloat(form.totalAmountRequested.replace(/,/g, '')) || 0;
    return requestedAmount > offeredAmount;
  };

  const handleSubmit = async () => {
    if (validateForm()) {

             const response = await Postrequest("/auth/create_disbursement_request",form,accesstoken)
               
              if(response.status){

                  Navigate("/application/offers/inprinciple_offer_student")
                  toast.success(response.textStatus)
                  SoundAlert("success")
              }
          

    } else {
       SoundAlert("error")
       toast.warning("Please fill in all required fields.");
     
    }
  };




  useEffect(()=>{

       (async()=>{

          const response = await Getrequest(`/auth/get_disbursement_request/${UserTokens}`,accesstoken)

          if(response?.data){
         
               if(response.data.user_token === UserTokens){

                   
                     if(response.data.accept_request === "returned_request"){

                    setForm((prevForm) => ({...prevForm, accept_request: response.data.accept_request}))
                    toast.warn("Returned disbursement request detected. Please edit and resubmit your request.")
                    SoundAlert("error")
                     }else{


                    Navigate("/application/offers/inprinciple_offer_student")
                    toast.warn("You have already submitted a disbursement request")
                    SoundAlert("error")
                     }

                   
              
                  
               }
              
          }


       })();




  },[])





  return (
    <Box sx={{ p: 2, maxWidth: "900px", mx: "auto" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        REQUEST FOR DISBURSEMENT AND UTILIZATION OF KADUNA STATE STUDENTS TERTIARY EDUCATION LOAN (STUDENT LOAN ) 
      </Typography>
      <Typography className="!bg-red-950 !text-white !p-3">
         Kindly note that your disbursement request will be processed based on the approved loan amount of <strong>{form.disbursementAmountFigure}</strong>. Please ensure that the total disbursement amounts requested do not exceed this approved amount.
      </Typography>

    {/*   <Typography variant="body1" sx={{ mb: 2 }}>
        REQUEST FOR DISBURSEMENT AND UTILIZATION OF KADUNA STATE STUDENTS
        TERTIARY EDUCATION LOAN (THIRD PARTY)
      </Typography> */}

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="CLIENT's NAME"
              name="clientName"
              value={form.clientName}
              onChange={handleChange}
              placeholder="e.g. John Doe"
              disabled
            />
          </Grid>


            <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Approved  Amount"
              name="disbursementAmountFigure"
              value={form.disbursementAmountFigure}
              onChange={handleChange}
              disabled
            />
          </Grid>

          

         {/*  <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Disbursement Amount (text)"
              name="disbursementAmountText"
              value={form.disbursementAmountText}
              onChange={handleChange}
              disabled
            />
          </Grid>  */} 


          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Student Name (for disbursement)"
              name="disbursementStudentName"
              value={form.disbursementStudentName}
              onChange={handleChange}
              placeholder="e.g. John Doe"
              disabled
            />
          </Grid>
        </Grid>
{/* 
    const numericAmount = Number(amountOffered.replace(/,/g, ""));
    const amountInWords = toWords(numericAmount); */}
        <Box sx={{ mt: 2 }}>
           {
            form.disbursementAmountText &&
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            Further to my Loan request, kindly approve disbursement and utilization of{" "}
            <strong>{form.disbursementAmountText}</strong>{" "}
            in favour of Student Name <strong>{form.disbursementStudentName || "………………………….."}</strong>
            {"\n"}as follows:
          </Typography>
           }
        </Box>
      </Paper>

     {/*  <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          A.B.U Microfinance Bank account number
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "#d32f2f", fontWeight: "bold" }}>
          ⚠️ IMPORTANT: You must create an account through our partner bank, A.B.U
          Microfinance Bank. All loan disbursements will be transferred directly to
          this account. Providing an incorrect or false account number will result in
          automatic disqualification.
        </Typography>

        <p className="p-2">
          Please download their mobile app from the Play Store and sign up. If you
          don't have one, click the link below to download and open a bank account and input the
          account number in the requested place.
        </p>

        <p className="p-4 text-blue-800 underline">
          <a
            href="https://apps.apple.com/ng/app/moneta/id6446173062"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to open an A.B.U Microfinance Bank account
          </a>
        </p>

         <p className="p-4 text-blue-800 underline">
           App name is : <b>"Moneta"</b>
        </p>
 
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Account Number *"
              name="loanbank_account_number"
              value={form.loanbank_account_number}
              onChange={handleChange}
              error={!!errors.loanbank_account_number}
              helperText={errors.loanbank_account_number}
              inputProps={{
                inputMode: "numeric",
                maxLength: 10,
              }}
            />
          </Grid>
        </Grid>
      </Paper> */}

      {/* Payment Type Selection */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Payment Type
        </Typography>
        <RadioGroup
          row
          name="paymentType"
          value={form.paymentType}
          onChange={handleRadioChange}
        >
          <FormControlLabel
            value="local"
            control={<Radio />}
            label="Local Payment"
          />
          <FormControlLabel
            value="international"
            control={<Radio />}
            label="International Payment"
          />
        </RadioGroup>
      </Paper>

      {!form.isInternational && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            A(a) / A(b) Selection
          </Typography>
          <RadioGroup
            row
            name="localSectionChoice"
            value={form.localSectionChoice}
            onChange={handleLocalSectionChoiceChange}
          >
            <FormControlLabel
              value="remita"
              control={<Radio />}
              label="School Remita payment"
            />
            <FormControlLabel
              value="backing"
              control={<Radio />}
              label="School Backing Details Upload"
            />
            <FormControlLabel value="both" control={<Radio />} label="Both" />
          </RadioGroup>
        </Paper>
      )}

      {/* SECTION A(a) - Show only for local payment */}
      {!form.isInternational &&
        (form.localSectionChoice === "remita" || form.localSectionChoice === "both") && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            1. DETAILS OF INSTITUTION AND STUDENT – A(a) *
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Account Name *"
                name="a_accountName"
                value={form.a_accountName}
                onChange={handleChange}
                error={!!errors.a_accountName}
                helperText={errors.a_accountName}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Remita *"
                name="a_remita"
                value={form.a_remita}
                onChange={handleChange}
                error={!!errors.a_remita}
                helperText={errors.a_remita}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount *"
                name="a_amount"
                value={form.a_amount}
                onChange={handleChange}
                error={!!errors.a_amount}
                helperText={errors.a_amount}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                label="Student Name"
                name="a_studentName"
                value={form.a_studentName}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Level *"
                name="a_level"
                value={form.a_level}
                onChange={handleChange}
                error={!!errors.a_level}
                helperText={errors.a_level}
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* SECTION A(b) - Show only for local payment */}
      {!form.isInternational &&
        (form.localSectionChoice === "backing" || form.localSectionChoice === "both") && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            A(b) Upload Backing Documents *
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_schoolName"
                label="School Name *"
                value={form.b_schoolName}
                onChange={handleChange}
                error={!!errors.b_schoolName}
                helperText={errors.b_schoolName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_schoolAccountName"
                label="School Account Name *"
                value={form.b_schoolAccountName}
                onChange={handleChange}
                error={!!errors.b_schoolAccountName}
                helperText={errors.b_schoolAccountName}
              />
            </Grid>

             <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_schoolAccountNumber"
                label="School Account Number *"
                value={form.b_schoolAccountNumber}
                onChange={handleChange}
                error={!!errors.b_schoolAccountNumber}
                helperText={errors.b_schoolAccountNumber}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_bank"
                label="Bank *"
                value={form.b_bank}
                onChange={handleChange}
                error={!!errors.b_bank}
                helperText={errors.b_bank}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="b_studentName"
                label="Student Name"
                value={form.b_studentName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_level"
                label="Level *"
                value={form.b_level}
                onChange={handleChange}
                error={!!errors.b_level}
                helperText={errors.b_level}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="b_matricNo"
                label="Matric No"
                value={form.b_matricNo}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="b_course"
                label="Course of Study"
                value={form.b_course}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="b_amount"
                label="Amount *"
                value={form.b_amount}
                onChange={handleChange}
                error={!!errors.b_amount}
                helperText={errors.b_amount}
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* SECTION A(c) - Show only for international payment */}
      {form.isInternational && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            A(c) Upload Backing Documents (International Payment) *
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_schoolName"
                label="School Name *"
                value={form.c_schoolName}
                onChange={handleChange}
                error={!!errors.c_schoolName}
                helperText={errors.c_schoolName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_schoolAccountName"
                label="School Account Name *"
                value={form.c_schoolAccountName}
                onChange={handleChange}
                error={!!errors.c_schoolAccountName}
                helperText={errors.c_schoolAccountName}
              />
            </Grid>
             <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_schoolAccountNumber"
                label="School Account Number *"
                value={form.c_schoolAccountNumber}
                onChange={handleChange}
                error={!!errors.c_schoolAccountNumber}
                helperText={errors.c_schoolAccountNumber}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_bank"
                label="Bank *"
                value={form.c_bank}
                onChange={handleChange}
                error={!!errors.c_bank}
                helperText={errors.c_bank}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_amount"
                label="Amount *"
                value={form.c_amount}
                onChange={handleChange}
                error={!!errors.c_amount}
                helperText={errors.c_amount}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="c_course"
                label="Course of Study"
                value={form.c_course}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_iban"
                label="IBAN *"
                value={form.c_iban}
                onChange={handleChange}
                error={!!errors.c_iban}
                helperText={errors.c_iban}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_swift"
                label="Swift Code *"
                value={form.c_swift}
                onChange={handleChange}
                error={!!errors.c_swift}
                helperText={errors.c_swift}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_branch"
                label="Branch *"
                value={form.c_branch}
                onChange={handleChange}
                error={!!errors.c_branch}
                helperText={errors.c_branch}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="c_matricNo"
                label="Matric No"
                value={form.c_matricNo}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                fullWidth
                name="c_studentName"
                label="Student Name"
                value={form.c_studentName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="c_level"
                label="Level *"
                value={form.c_level}
                onChange={handleChange}
                error={!!errors.c_level}
                helperText={errors.c_level}
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* UPKEEP */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          2. UPKEEP *
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Student Account Name *"
              name="up_name"
              value={form.up_name}
              onChange={handleChange}
              error={!!errors.up_name}
              helperText={errors.up_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Account Number *"
              name="up_accNo"
              value={form.up_accNo}
              onChange={handleChange}
              error={!!errors.up_accNo}
              helperText={errors.up_accNo}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Bank *"
              name="up_bank"
              value={form.up_bank}
              onChange={handleChange}
              error={!!errors.up_bank}
              helperText={errors.up_bank}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Amount *"
              name="up_amount"
              value={form.up_amount}
              onChange={handleChange}
              error={!!errors.up_amount}
              helperText={errors.up_amount}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* SKILLS */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          3. SKILLS ACQUISITION *
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Centre Name / Skill *"
              name="sk_centre"
              value={form.sk_centre}
              onChange={handleChange}
              error={!!errors.sk_centre}
              helperText={errors.sk_centre}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Centre Account Name *"
              name="sk_centreAcc"
              value={form.sk_centreAcc}
              onChange={handleChange}
              error={!!errors.sk_centreAcc}
              helperText={errors.sk_centreAcc}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Account Number *"
              name="sk_accNo"
              value={form.sk_accNo}
              onChange={handleChange}
              error={!!errors.sk_accNo}
              helperText={errors.sk_accNo}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Bank *"
              name="sk_bank"
              value={form.sk_bank}
              onChange={handleChange}
              error={!!errors.sk_bank}
              helperText={errors.sk_bank}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Amount *"
              name="sk_amount"
              value={form.sk_amount}
              onChange={handleChange}
              error={!!errors.sk_amount}
              helperText={errors.sk_amount}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* OTHERS */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          4. OTHERS
        </Typography>

        <RadioGroup
          row
          value={form.hasOthers ? "yes" : "no"}
          onChange={handleOthersRadioChange}
          sx={{ mb: 2 }}
        >
          <FormControlLabel value="no" control={<Radio />} label="No" />
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        </RadioGroup>

        {form.hasOthers && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="oth_name"
                label="Student Account Name *"
                value={form.oth_name}
                onChange={handleChange}
                error={!!errors.oth_name}
                helperText={errors.oth_name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="oth_accNo"
                label="Account Number *"
                value={form.oth_accNo}
                onChange={handleChange}
                error={!!errors.oth_accNo}
                helperText={errors.oth_accNo}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="oth_bank"
                label="Bank *"
                value={form.oth_bank}
                onChange={handleChange}
                error={!!errors.oth_bank}
                helperText={errors.oth_bank}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="oth_amount"
                label="Amount *"
                value={form.oth_amount}
                onChange={handleChange}
                error={!!errors.oth_amount}
                helperText={errors.oth_amount}
              />
            </Grid>
          </Grid>
        )}
      </Paper>

      {/* Amount Exceeded Warning */}
      {isAmountExceeded() && (
        <Alert severity="error" sx={{ mb: 2 }}>
          <strong>Amount Exceeded!</strong> The total amount requested (₦{form.totalAmountRequested}) is higher than the approved loan amount (₦{parseFloat(amountOffered.replace(/,/g, '')).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}). Please adjust your disbursement amounts.
        </Alert>
      )}

      {/* SUBMIT BUTTON */}
      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={handleSubmit}
        disabled={isAmountExceeded()}
        sx={{ mt: 2 }}
      >
        Submit Request
      </Button>
    </Box>
  );


}
